import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '../services/user.service';
import { Subject } from 'rxjs';
import { UtilityService } from '../services/utility.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {
      //New Site Work start
      public shouldShow = false;
      public SubmenuShow1 = false;
      public SubmenuShow2 = false;
      public SubmenuShow3 = false;
      public SubmenuShow4 = false;
      public SubmenuShow5 = false;
      public SubmenuShow6 = false;
      public SubmenuShow7 = false;
      public SubmenuShow8 = false;
      public SubmenuShow9 = false;
      public SubmenuShow10 = false;
      public SubmenuShow11 = false;
      public SubmenuShow12 = false;
      animation = 'pulse';
      contentLoaded = false;
    login_UserID: any;
  userRole: number;
  unsubscribe$: Subject<boolean> = new Subject();
      //intervalId;
  profile: string;

  constructor(private userService: UserService, private _utilityService: UtilityService,private _router: Router) { }

  ngOnInit() {
    ;
    this._utilityService.getProfileObs().subscribe(profile => this.profile = profile);
    var user = this.userService.getUserInfo();
    
    this.login_UserID = user.id;
    this.userRole = Number(user.role);
    if (this.userRole != 1) {
      this._router.navigate(['/dashboard'])
    }
    //New Site Work start
    setTimeout(() => {
      this.contentLoaded = true;
    }, 2000);
      }
      toggleSideMenu() {
        
      setTimeout(() => {
  }, 500)

  }
 
  ngOnDestroy() {
    this.unsubscribe$.next(true);
    this.unsubscribe$.complete();
  }
  routeToReport() {
    this._router.navigate(['./report']);
    return false;
  }
}
